export default {"src":"/_next/static/media/userGroup.7bb40760.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};